module.exports = __webpack_public_path__ + "img/johan.c98fd55a.png";